export class Lesson {
    id: number = 0
    description: string = ""
    date: Date = new Date()
    price: number = 0
    length: Date = new Date()
    room_number: number = 0
    total_spots: number = 0
    free_spots: number = 0
    enrolled_spots: number = 0
    coach: string = ""
    reservation_number: number | null = null

    getEndDate() : Date{
        return new Date(
            this.date.getTime() + 
            (this.length.getUTCHours() * 3600 * 1000) + 
            (this.length.getUTCMinutes() * 60 * 1000) + 
            (this.length.getUTCSeconds() * 1000)
        );
    }

    static instance(lesson: any){
        // console.log(lesson);
        
        const l = new Lesson()
        l.id = lesson.ID_LEKCE;
        l.description = lesson.POPIS;
        l.room_number = lesson.CISLO_SALU;
        l.total_spots = lesson.KAPACITA;
        l.free_spots = lesson.VOLNE;
        l.enrolled_spots = lesson.ZAPSANE;
        l.coach = lesson.OSLOVENI;
        l.date = new Date(lesson.DATUM);
        l.length = new Date(lesson.DELKA);
        l.price = lesson.CENA;
        l.reservation_number = lesson.CISLO_REZERVACE
        return l;
    }
}